<template>
  <el-dialog
    v-if="dialogVisible"
    :show-close="false"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    append-to-body
    width="98%"
  >
    <div slot="title" style="max-width: 1350px" class="header-title">
      <span style="font-size: 17px; font-weight: bold; text-align: left">
        {{ "设置排期资源" }}</span
      >&nbsp;&nbsp;
      <span style="color: #ffb017"> {{ afferentParam.title }}</span>
    </div>
    <div style="margin-top: 5px">
      <el-row :gutter="10">
        <el-col :span="17">
          <div
            style="
              border: 1px solid #e4e7ed;
              border-top: none;
              border-bottom: none;
              border-left: none;
            "
          >
            <el-tabs v-model="afferentParam.type" @tab-click="handleClick">
              <el-tab-pane label="培训师" name="trainer">
                <trainer-room
                  ref="trainerRef"
                  :siteId="afferentParam.siteId"
                  :courseId="afferentParam.courseId"
                  :startTime="afferentParam.startTime"
                  :endTime="afferentParam.endTime"
                  :day="afferentParam.day"
                ></trainer-room>
                <scheduling-div
                  :schedulingName="trainerName"
                  v-on:closeResDialog="closeResDialog"
                  ref="trainerDivRef"
                ></scheduling-div>
              </el-tab-pane>
              <el-tab-pane label="教室" name="classroom">
                <class-room
                  ref="classroomRef"
                  :siteId="afferentParam.siteId"
                  :courseId="afferentParam.courseId"
                  :startTime="afferentParam.startTime"
                  :endTime="afferentParam.endTime"
                            :day="afferentParam.day"
                            :venueType="afferentParam.venueType"></class-room>
                <!--</div>-->
                <scheduling-div :schedulingName="schedulingName"
                  v-on:closeResDialog="closeResDialog"
                  ref="classRoomDivRef"
                ></scheduling-div>
              </el-tab-pane>
              <el-tab-pane label="车辆" name="vehicle">
                <vehicle-class
                  ref="vehicleRef"
                  :siteId="afferentParam.siteId"
                  :courseId="afferentParam.courseId"
                  :startTime="afferentParam.startTime"
                  :endTime="afferentParam.endTime"
                  :day="afferentParam.day"
                ></vehicle-class>
                <scheduling-div
                  :schedulingName="vehicleName"
                  v-on:closeResDialog="closeResDialog"
                  ref="vehicleDivRef"
                ></scheduling-div>
              </el-tab-pane>
              <!--              <el-tab-pane label="资产耗材"-->
              <!--                           name="consumables">-->
              <!--                  该功能暂未实现，敬请期待-->
              <!--              </el-tab-pane>-->
            </el-tabs>
          </div>
        </el-col>

        <!--已选资源-->
        <el-col :span="7">
          <selected-resources
            ref="selectedResourcesRef"
            :afferentParam="afferentParam"
            v-on:closeResDialog="closeResDialog"
            v-on:resourceBack="resourceBack"
            :tabName="afferentParam.type"
          ></selected-resources>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
import SchedulingDIV from "@/components/rm/resouce-select/schedulingDiv.vue";
import selectedResources from "@/components/rm/resouce-select/selectedResources.vue";
import ClassRoom from "@/components/rm/class-room/index";
import Trainer from "@/components/rm/trainer/index";
import vehicleClass from "@/components/rm/vehicle-class/index";

export default {
  name: "resouce-select",
  props: {
    // 对话框显示开关
    dialogVisible: Boolean,
    // 传入参数
    afferentParam: {
      type: Object,
    },
    courseId: String,
  },
  components: {
    "scheduling-div": SchedulingDIV,
    "class-room": ClassRoom,
    "trainer-room": Trainer,
    "vehicle-class": vehicleClass,
    "selected-resources": selectedResources,
  },
  data() {
    return {
      // tab标签页, 默认显示 培训师
      // activeName: 'trainer',
      // 日程安排 名称
      schedulingName: "教室日程安排",
      trainerName: "培训师日程安排",
      vehicleName: "车辆日程安排",
      dataListLoading: false,
      vehicleData: [],
      isR: false, //只让updated的广播只创建一次
      dataForm: {
        siteCnName: "",
        siteNo: "",
        siteClassList: [],
        statusList: [],
        courseId: this.courseId,
      },
    };
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.$eventHub.$on("initMethod", (data) => {
      this.initMethod();
    });
  },
  methods: {
    // 初始化
    initMethod() {
      // 调用车辆tab的初始化方法
      this.$refs.vehicleRef && this.$refs.vehicleRef.initMethod();
      // 调用教室tab的初始化方法
      this.$refs.classroomRef && this.$refs.classroomRef.initMethod();
      // 调用培训师tab的初始化方法
      this.$refs.trainerRef && this.$refs.trainerRef.initMethod();
      // 如果是已选资源的初始化方法
      this.$refs.selectedResourcesRef &&
        this.$refs.selectedResourcesRef.initMethod();
    },
    // 关闭dialog调用父组件的关闭方法
    handleBeforeClose() {
      this.$emit("closeResDialog");
    },
    // tab 标签 点击事件
    handleClick(tab, event) {
      if (this.afferentParam.type === "classroom") {
        // 调用页面查询方法
        this.$refs.classroomRef.queryClassroom();
      } else if (this.afferentParam.type === "trainer") {
        // 调用页面查询方法
        this.$refs.trainerRef.queryTrainer();
      } else {
        // 调用页面查询方法
        this.$refs.vehicleRef.queryVehicle();
      }
    },
    // 关闭dialog
    closeResDialog() {
      this.dialogVisible = false;
      this.$emit("closeResDialog");
    },
    // 带回主页面
    resourceBack(data) {
      this.$emit("resourceBack", data);
    },
  },
  updated() {
    console.log("updated");
    if (!this.isR) {
      this.isR = true;
      // this.$refs.vehicleRef.initMethod();
      // this.$refs.classroomRef.initMethod();
      // this.$refs.trainerRef.initMethod();

      this.$eventHub.$on("select_classroomUpdate_wxl", (data, dataForm) => {
        this.$refs.classRoomDivRef &&
          this.$refs.classRoomDivRef.queryScheduling(data, dataForm);
      });
      this.$eventHub.$on("select_trainerUpdate_wxl", (data, dataForm) => {
        this.$refs.trainerDivRef &&
          this.$refs.trainerDivRef.queryScheduling(data, dataForm);
      });
      this.$eventHub.$on("select_vehicleUpdate_wxl", (data, dataForm) => {
        this.$refs.vehicleDivRef &&
          this.$refs.vehicleDivRef.queryScheduling(data, dataForm);
      });
    }
  },
  beforeDestroy() {
    this.isR = false;
    this.$eventHub.$off("select_classroomUpdate_wxl");
    this.$eventHub.$off("select_trainerUpdate_wxl");
    this.$eventHub.$off("select_vehicleUpdate_wxl");
  },
};
</script>
<style lang='scss' scoped>
/* 查询div 样式设置 */
.select-div {
  height: 300px;
  border: 1px solid #974;
}
/* 日程安排 DIV 样式设置 */
.schedule-div {
  height: 200px;
  border: 1px solid #886;
}
/* 已选内容 */
.selected-div {
  height: 400px;
  border: 1px solid #aa00aa;
}
</style>
